{"name": "nextgen-bitbrew-web", "buildversion": "1.0.14_11042026-110706", "buildTime": "04/11/2026 11:07:07"}